import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'BESCSwap | XRPL DEX',
  description: 'XRPL-native AMM + order book DEX. Swap, add liquidity, and earn BESC rewards on the XRP Ledger.',
  image: 'https://xrpbescswaps.com/logo1.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath
  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/add')) {
    basePath = '/add'
  } else if (path.startsWith('/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/info')) {
    basePath = '/info'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/':
      return {
        title: `${t('Home')} | ${t('BESCSWAP')}`,
      }
    case '/swap':
      return {
        title: `${t('Exchange')} | ${t('BESCSWAP')}`,
      }
    case '/add':
      return {
        title: `${t('Add Liquidity')} | ${t('BESCSWAP')}`,
      }
    case '/remove':
      return {
        title: `${t('Remove Liquidity')} | ${t('BESCSWAP')}`,
      }
    case '/liquidity':
      return {
        title: `${t('Liquidity')} | ${t('BESCSWAP')}`,
      }
    case '/find':
      return {
        title: `${t('Import Pool')} | ${t('BESCSWAP')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('BESCSWAP')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('BESCSWAP')}`,
      }
    case '/info':
      return {
        title: `${t('Charts')} | ${t('BESCSWAP')}`,
        description: 'Live market data and price action for XRP and supported pairs.',
      }
    default:
      return null
  }
}
